import React, { useState, useRef, useEffect } from "react";
import { GLOBAL_IMAGES } from "../assets/asset";
import { COMPONENTS_NAV } from "../assets/asset";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  const [allImagesLoaded, setAllImagesLoaded] = useState(false);
  const loadedImagesCount = useRef(0);
  const totalImages = 3;

  const handleNavigation = (urlStr) => {
    navigate(urlStr);
  };

  const handleImageLoad = () => {
    loadedImagesCount.current += 1;
    if (loadedImagesCount.current === totalImages) {
      setAllImagesLoaded(true);
    }
  };

  // Preload images function
  const preloadImages = () => {
    const imageUrls = [
      GLOBAL_IMAGES.onboarding_bg,
      GLOBAL_IMAGES.dingo,
      COMPONENTS_NAV.nav_main
    ];

    imageUrls.forEach((url) => {
      const img = new Image();
      img.onload = handleImageLoad;
      img.onerror = handleImageLoad; // Handle errors to prevent hanging
      img.src = url;
    });
  };

  useEffect(() => {
    preloadImages();
  }, []);

  // Loading screen component
  const LoadingScreen = () => (
    <div className="flex items-center justify-center w-screen min-h-screen bg-gray-100">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#08059B] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#08059B] font-mali text-lg font-semibold">Loading...</p>
      </div>
    </div>
  );

  // Show loading screen until all images are loaded
  if (!allImagesLoaded) {
    return <LoadingScreen />;
  }

  // Main content - only renders when all images are loaded
  return (
    <div
      className="flex flex-col w-screen min-h-screen items-center justify-between py-4 px-4"
      style={{
        backgroundImage: `url(${GLOBAL_IMAGES.onboarding_bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="flex w-full items-start justify-between mb-4">
        <img 
          className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24" 
          src={GLOBAL_IMAGES.dingo} 
          alt="Dingo Logo"
        />
        <div className="mt-4 flex flex-col items-center text-center px-2 sm:mt-6 md:mt-8">
          <div
            className="font-inter text-[2.5rem] font-extrabold uppercase leading-none tracking-[0.02em] sm:text-[3.4rem] md:text-[4.4rem] lg:text-[4.9rem]"
            aria-label="Mathdingo"
          >
            <span className="text-[#1E1E1E]">M</span>
            <span className="text-[#F4C430]">A</span>
            <span className="text-[#2657C8]">T</span>
            <span className="text-[#1E1E1E]">H</span>
            <span className="text-[#2657C8]">D</span>
            <span className="text-[#F4C430]">I</span>
            <span className="text-[#2657C8]">N</span>
            <span className="text-[#1E1E1E]">G</span>
            <span className="text-[#2657C8]">O</span>
          </div>
          <p className="mt-4 max-w-sm text-base font-mali text-black sm:max-w-md sm:text-lg md:max-w-xl md:text-xl lg:text-2xl">
            Used by Australian parents and schools to make maths easier, more
            engaging and more effective.
          </p>
        </div>
        <div className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24"></div>
      </div>
      
      <div className="flex-1 flex flex-col items-center justify-center text-center gap-6 w-full max-w-lg px-4">
        <img
          className="w-full max-w-xs sm:max-w-sm md:max-w-md h-auto object-contain"
          src={COMPONENTS_NAV.nav_main}
          alt="Main Navigation"
        />
        <button
          className="flex items-center justify-center text-white w-64 h-12 bg-[#08059B] rounded-md shadow-md font-mali"
          onClick={() => handleNavigation("/createaccount")}
        >
          Start Free Trial
        </button>
        <button
          className="flex items-center justify-center text-white w-64 h-12 bg-[#08059B] rounded-md shadow-md font-mali"
          onClick={() => handleNavigation("/login")}
        >
          Already registered? Login
        </button>
      </div>
      
      <div className="h-4"></div>
    </div>
  );
};

export default Navbar;
